export const smsKeys = {
  all: () => ['sms-overview'] as const,
  smsUsers: () => ['sms-users'] as const,
};
